var _style, _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInBrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-10 -10 140 140",
    style: {
      enableBackground: "new 0 0 118.02 118.41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.all{vector-effect:non-scaling-stroke;fill:#2DA4AD;stroke:#2DA4AD;stroke-linecap:round;stroke-miterlimit:10;stroke-width:6}\n\t.st1{fill:none;}\n\t.st2{stroke-width:4;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 58.68,
    cy: 59.42,
    r: 56.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "all st1 icon_status",
    d: "M59.01,3c30.93,0,56.01,25.16,56.01,56.2s-25.08,56.2-56.01,56.2S3,90.25,3,59.2c0-11.64,3.53-22.45,9.57-31.42 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "all st2 icon_detail",
    d: "M35.47,80.34c-2.52,0-5.06-0.5-7.55-1.49c-3.22-1.28-5.85-3.52-7.59-6.33c3.14,1.95,6.6,2.91,10.45,2.91 c3.21,0,6.74-0.68,10.77-2.08C49.44,70.61,51.7,63,52.79,56.67c0.19-1.08,0.36-2.18,0.54-3.27c0.57-3.56,1.17-7.25,2.17-10.65 c2.46-8.39,7.77-13.16,15.8-14.18c1.17-0.15,2.32-0.22,3.41-0.22c6.85,0,12.01,2.95,15.35,8.75c1.8,3.13,2.99,7.5,3.17,11.69 c0.34,7.57,0.27,15.03,0.21,22.92c-0.02,2.48-0.04,4.97-0.05,7.48h-5.27c-0.03-0.62-0.06-1.22-0.06-1.81c-0.01-3.33,0-6.65,0-9.98 c0.01-5.9,0.02-12.01-0.03-18.01c-0.08-9.15-3.44-13.96-10.89-15.59c-1.04-0.23-2.1-0.34-3.15-0.34c-6.46,0-11.92,4.22-13.9,10.74 c-1.11,3.64-1.77,7.45-2.42,11.13c-0.27,1.51-0.53,3.02-0.82,4.52C54.43,72.1,45.84,80.34,35.47,80.34z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "all st2 icon_detail",
    d: "M22.95,62.26c-4.59-3.53-4.67-5.3-1.26-11.06l0.67-1.13c2.17-3.65,4.42-7.42,6.1-11.49 c1.02-2.47,1.52-5.08,2.05-7.84c0.13-0.69,0.27-1.4,0.41-2.11h3.98c0.31,3.25-0.23,6.62-1.58,9.85c-1.23,2.93-2.7,5.83-4.13,8.64 c-1.22,2.4-2.48,4.89-3.61,7.42c-1,2.25-1.69,4.57-2.42,7.03C23.09,61.8,23.02,62.03,22.95,62.26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "all st2 icon_detail",
    d: "M32.87,13.39c-2.05-0.06-3.44-1.5-3.47-3.6c-0.01-1.08,0.31-1.98,0.92-2.61c0.63-0.63,1.54-0.97,2.64-0.97 c1.12,0.01,2.09,0.39,2.76,1.09c0.64,0.66,0.97,1.53,0.95,2.51c-0.04,1.93-1.74,3.57-3.7,3.57L32.87,13.39z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInBrace);
export default __webpack_public_path__ + "static/media/InBrace.592816f3cccc3b5adff5af67a9c1d863.svg";
export { ForwardRef as ReactComponent };